import Tables from './Tables.js'

export default Tables